(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2393],{

/***/ 16161:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for/[slug]",
      function () {
        return __webpack_require__(34978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ HighlightCodeBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Docs/Docs.module.scss
var Docs_module = __webpack_require__(75698);
var Docs_module_default = /*#__PURE__*/__webpack_require__.n(Docs_module);
// EXTERNAL MODULE: ./node_modules/react-code-blocks/dist/react-code-blocks.esm.js + 13 modules
var react_code_blocks_esm = __webpack_require__(41443);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/CodeBlock/highlight-code-theme.ts
var highlight_code_theme = __webpack_require__(10198);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/document-duplicate.svg
/* harmony default export */ var document_duplicate = ({"src":"/_next/static/media/document-duplicate.070abf52.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/images/checkmark_circle.svg
/* harmony default export */ var checkmark_circle = ({"src":"/_next/static/media/checkmark_circle.ba3ad5e6.svg","height":16,"width":16});
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 2 modules
var listbox = __webpack_require__(79949);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronUpDownIcon.js
var ChevronUpDownIcon = __webpack_require__(46032);
;// CONCATENATED MODULE: ./components/Docs/HighlightCodeBlock/HighlightCodeBlock.tsx












const HighlightCodeBlock = (props)=>{
    const [copied, setCopied] = (0,react.useState)(false);
    const [selected, setSelected] = (0,react.useState)(0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Docs_module_default()).codeBlock,
        style: props.style,
        children: [
            props.topbar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Docs_module_default()).codeBlockTopper,
                children: props.product.types && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-28 ml-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
                        value: selected,
                        onChange: setSelected,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                                    className: "relative w-full cursor-pointer rounded-lg bg-dark-background py-2 my-[10px] pl-3 pr-4 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy4",
                                            emphasis: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block truncate",
                                                children: props.product.types[selected]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpDownIcon/* default */.Z, {
                                                className: "h-5 w-5 text-gray-400",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                    as: react.Fragment,
                                    leave: "transition ease-in duration-100",
                                    leaveFrom: "opacity-100",
                                    leaveTo: "opacity-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                        className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md border-2 border-divider-on-dark bg-color-primary-500 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                        children: props.product.types.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                                className: (param)=>{
                                                    let { active  } = param;
                                                    return "relative cursor-pointer select-none mx-1 py-1 pl-2 pr-4 rounded-md ".concat(active ? "bg-divider-on-dark text-white" : "text-copy-on-dark");
                                                },
                                                value: index,
                                                children: (param)=>/*#__PURE__*/ {
                                                    let { selected  } = param;
                                                    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "block truncate ".concat(selected ? "font-medium" : "font-normal"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                                type: "copy4",
                                                                emphasis: true,
                                                                children: type
                                                            })
                                                        })
                                                    });
                                                }
                                            }, index))
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_code_blocks_esm/* CodeBlock */.dn, {
                language: props.language,
                text: props.text || props.product.snippets[selected] || "",
                showLineNumbers: props.showLineNumbers,
                theme: highlight_code_theme/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Docs_module_default()).codeCopyIcon, "".concat(props.topbar ? "mt-1" : "")),
                onClick: ()=>{
                    var _text;
                    navigator.clipboard.writeText((_text = props.text) !== null && _text !== void 0 ? _text : "");
                    setCopied(true);
                    setTimeout(()=>setCopied(false), 1000);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: document_duplicate,
                    alt: "Copy"
                })
            }),
            copied && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Docs_module_default()).codeCopyIcon, (Docs_module_default()).active, "".concat(props.topbar ? "mt-1" : "")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: checkmark_circle,
                    alt: "Text Copied"
                })
            })
        ]
    });
};


/***/ }),

/***/ 34978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 3 modules
var Navbar = __webpack_require__(77911);
// EXTERNAL MODULE: ./components/Products/Products.module.scss
var Products_module = __webpack_require__(49879);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
;// CONCATENATED MODULE: ./components/Products/FeatureBox.tsx



const FeatureBox = (param)=>{
    let { title , desc , icon  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Products_module_default()).featureBox,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Products_module_default()).featureBoxIcon,
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Products_module_default()).featureBoxText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy2",
                        emphasis: true,
                        className: "text-white",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy3",
                        className: "text-color-darker-copy-on-dark",
                        children: desc
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Products_FeatureBox = (FeatureBox);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/Docs/HighlightCodeBlock/HighlightCodeBlock.tsx + 2 modules
var HighlightCodeBlock = __webpack_require__(96736);
;// CONCATENATED MODULE: ./public/images/products-replay.png
/* harmony default export */ var products_replay = ({"src":"/_next/static/media/products-replay.50f0acc5.png","height":759,"width":1140,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAElBMVEUcEzgkJkwbGj4OAycXDTAlHD4A3xK9AAAAA3RSTlP+8fGCMYhyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVQImS3EgQkAMAjEwKj5/VeWFnMQ5uIPBlWCmKBAdz21CZoAY3YJ4kwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/products-errors.png
/* harmony default export */ var products_errors = ({"src":"/_next/static/media/products-errors.a1af7f1b.png","height":808,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJ1BMVEUOAycNBypOT28OBSgSDC0YES4WDTFMaXFAOGZNTIp0YqxpdJcxS3wgqgKxAAAADXRSTlPUJBODNAiMAEEnJTYh6QsZRAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACxJREFUCJkdwQkOACAIA7AxjgH6//ea2EK7JFPQnDOXQnZ3mCWsqtzdEPjiARUuAL80UQ7AAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/products-graph.png
/* harmony default export */ var products_graph = ({"src":"/_next/static/media/products-graph.a45327f6.png","height":801,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAALVBMVEULACQQBSgOBigyKk4UCCoqHk80KFQWFTcNASQhH0AmGUcnGUU3K10PBCcQDzIJvxO1AAAADnRSTlP9xuMo1EWq2J39hIlh8YDZQSMAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAArSURBVAiZLcHBEQAgCAOwtoCAeuw/rh8TmJkVWYi4oRlhr3WyO0F3ukR8ehLVALAX9Wg1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./public/images/hero-bug-left.gif
var hero_bug_left = __webpack_require__(17565);
// EXTERNAL MODULE: ./public/images/hero-bug-right.gif
var hero_bug_right = __webpack_require__(52417);
// EXTERNAL MODULE: ./components/Animate.tsx
var Animate = __webpack_require__(60216);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/Home/Reviews.ts + 5 modules
var Reviews = __webpack_require__(83620);
// EXTERNAL MODULE: ./pages/index.tsx + 15 modules
var pages = __webpack_require__(62165);
// EXTERNAL MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx + 5 modules
var CompaniesReel = __webpack_require__(92905);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/Products/InfoRow.tsx
var InfoRow = __webpack_require__(15099);
;// CONCATENATED MODULE: ./pages/for/[slug].tsx


























const Products = (param)=>{
    let { product  } = param;
    const reviewsRef = (0,react.useRef)(null);
    const scrollYPosition = (0,react.useRef)(0);
    const [scrollReviews, setScrollReviews] = (0,react.useState)(false);
    const [leftBugLoaded, setLeftBugLoaded] = (0,react.useState)(false);
    const [rightBugLoaded, setRightBugLoaded] = (0,react.useState)(false);
    const scrollListener = (0,react.useCallback)(()=>{
        if (!scrollReviews) {
            return;
        }
        if (reviewsRef.current) {
            const { scrollY  } = window;
            const scrollingDown = scrollYPosition.current > scrollY;
            // Adjust this value to control scroll speed
            const scrollDistance = scrollingDown ? -3 : 3;
            reviewsRef.current.scrollLeft += scrollDistance;
            scrollYPosition.current = scrollY;
        }
    }, [
        scrollReviews
    ]);
    (0,react.useEffect)(()=>{
        window.removeEventListener("scroll", scrollListener);
        window.addEventListener("scroll", scrollListener);
        return ()=>window.removeEventListener("scroll", scrollListener);
    }, [
        scrollListener
    ]);
    (0,react.useEffect)(()=>{
        const reviewsElement = reviewsRef.current;
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            setScrollReviews(entry.isIntersecting);
        }, {
            root: null,
            rootMargin: "250px 0px",
            threshold: 0
        });
        if (reviewsElement) {
            observer.observe(reviewsElement);
            // Scroll to center on load
            reviewsElement.scrollLeft = (reviewsElement.scrollWidth - window.innerWidth) / 2;
        }
        return ()=>{
            if (reviewsElement) {
                observer.unobserve(reviewsElement);
            }
        };
    }, [
        reviewsRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                hideBanner: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
                        className: (Home_module_default()).heroVideoWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateBugLeft */.ds, {
                                loaded: leftBugLoaded && rightBugLoaded,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Home_module_default()).heroBug,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: hero_bug_left/* default */.Z,
                                        alt: "bug left",
                                        onLoadingComplete: ()=>setLeftBugLoaded(true)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateBugRight */.nw, {
                                loaded: leftBugLoaded && rightBugLoaded,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Home_module_default()).heroBug,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: hero_bug_right/* default */.Z,
                                        alt: "bug right",
                                        onLoadingComplete: ()=>setRightBugLoaded(true)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorFeature,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Home_module_default()).anchorHead,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            children: [
                                                "The ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Home_module_default()).highlightedText,
                                                    children: product.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "monitoring toolkit ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                    className: "hidden sm:flex"
                                                }),
                                                "you've been waiting ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                    className: "hidden sm:flex"
                                                }),
                                                "for."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 sm:mt-8 px-4 max-w-[840px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                                type: "copy1",
                                                onDark: true,
                                                children: [
                                                    "What if monitoring your ",
                                                    product.title,
                                                    " app was as easy as deploying it? With session replay and error monitoring, Highlight's got you covered."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center my-14",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col sm:flex-row justify-center gap-4 w-screen sm:w-auto px-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        className: classnames_default()((Home_module_default()).solidButton, "min-w-[180px]"),
                                                        href: "https://app.highlight.io/?sign_up=1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Get started"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        href: "/docs",
                                                        className: classnames_default()((Products_module_default()).hollowButton),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Read our docs"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mb-20 md:mb-[160px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col lg:flex-row justify-center gap-4 px-4 lg:gap-12 lg:px-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_FeatureBox, {
                                    title: "Session Replay",
                                    desc: "Investigate hard-to-crack bugs by playing through issues in a youtube-like UI. With access to requests, console logs and more!",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsPlayCircleFill */.rUT, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_FeatureBox, {
                                    title: "Error Monitoring",
                                    desc: "Continuously monitor errors and exceptions in your ".concat(product.title, " application,\n                    all the way from your frontend to your backend."),
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsFillTerminalFill */.NV3, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_FeatureBox, {
                                    title: "Performance Metrics",
                                    desc: "Monitor and set alerts for important performance metrics in ".concat(product.title, "\n                    like Web Vitals, Request latency, and much more!"),
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsBarChartFill */.oh2, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center bg-color-primary-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Products_module_default()).anchorFeature,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Home_module_default()).anchorHead,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Products_module_default()).subtleBadge,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                                type: "copy4",
                                                emphasis: true,
                                                children: [
                                                    "Highlight for ",
                                                    product.title
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    "Get started in your ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                        className: "hidden sm:flex"
                                                    }),
                                                    product.title,
                                                    " app ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "today."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center my-14",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col lg:flex-row justify-center gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        href: "https://app.highlight.io/?sign_up=1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Get started for free"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                        href: product.docsLink,
                                                        className: (Products_module_default()).hollowButton,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy2",
                                                            emphasis: true,
                                                            children: "Read our docs"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-4/5 mb-20 md:mb-40",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCodeBlock/* HighlightCodeBlock */.d, {
                                        language: "js",
                                        product: product,
                                        showLineNumbers: false,
                                        topbar: true
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Products_module_default()).infoContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow/* default */.Z, {
                                title: "Reproduce issues with high-fidelity session replay.",
                                desc: "With our pixel-perfect replays of your ".concat(product.title, " app,\n            you'll get to the bottom of issues in no time and better\n            understand how your app is being used."),
                                link: product.docsLink,
                                linkText: "Read our docs",
                                imgSrc: products_replay
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Products_module_default()).divider
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow/* default */.Z, {
                                title: "Get a ping when exceptions or errors are thrown.",
                                desc: "Our alerting infrastructure can take abnormal metrics or\n            errors raised in your ".concat(product.title, " app and notify your\n            engineering team over Slack, Discord, and more!"),
                                link: product.docsLink,
                                linkText: "Read our docs",
                                imgSrc: products_errors,
                                invert: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Products_module_default()).divider
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow/* default */.Z, {
                                title: "Monitor the metrics that keep your customers around.",
                                desc: "Highlight allows you to track performance, request timings, and several other metrics\n            in your ".concat(product.title, " application."),
                                link: product.docsLink,
                                linkText: "Read our docs",
                                imgSrc: products_graph
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesReel/* CompaniesReel */.T, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).anchorFeature,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorHead,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    onDark: true,
                                    children: [
                                        "Don't take our word. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/customers",
                                            children: "What our customers have to say →"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).slider,
                        ref: reviewsRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).slideTrack,
                            children: [
                                ...Reviews/* REVIEWS */.t,
                                ...Reviews/* REVIEWS */.t
                            ].map((review, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(pages.CustomerReview, {
                                    companyLogo: review.companyLogo,
                                    text: review.text,
                                    author: review.author,
                                    scale: review.scale
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Products);


/***/ }),

/***/ 75698:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"Docs_mainWrapper__FXUeq","docsCard":"Docs_docsCard__otr1Y","docsCardGroup":"Docs_docsCardGroup__01dpF","docsCardPara":"Docs_docsCardPara__p_t5V","leftSection":"Docs_leftSection__obmR_","listItem":"Docs_listItem__yoc5q","active":"Docs_active__1H8j4","emptyContent":"Docs_emptyContent__HZyG5","searchResultCard":"Docs_searchResultCard__HoCml","content":"Docs_content__eXCi0","resultTitle":"Docs_resultTitle__u_Ok4","highlightedText":"Docs_highlightedText__qEoz1","tocIcon":"Docs_tocIcon__jhnhr","tocRow":"Docs_tocRow__uCwZO","tocChild":"Docs_tocChild__DEzRd","tocItem":"Docs_tocItem__zayx3","tocItemChevronClosed":"Docs_tocItemChevronClosed__vvJYn","tocItemOpen":"Docs_tocItemOpen__3TrfE","tocItemCurrent":"Docs_tocItemCurrent__I8muf","tocChildren":"Docs_tocChildren__PoknC","tocChildrenLineWrapper":"Docs_tocChildrenLineWrapper__GbkOD","tocChildrenLine":"Docs_tocChildrenLine__l3kNX","tocChildrenContent":"Docs_tocChildrenContent__yTpCr","pageTitle":"Docs_pageTitle__rtkmX","sdkPageTitle":"Docs_sdkPageTitle__koGyT","quickStartSubtext":"Docs_quickStartSubtext__F6fJJ","contentRender":"Docs_contentRender__xZOXl","sdkRightColumn":"Docs_sdkRightColumn__yipIy","sdkLeftColumn":"Docs_sdkLeftColumn__KZyoS","inlineCodeBlock":"Docs_inlineCodeBlock__i42rv","headingCopyIcon":"Docs_headingCopyIcon__L6gY8","docSelect":"Docs_docSelect__ry3Bu","docSelectText":"Docs_docSelectText__eKCeK","chevronDown":"Docs_chevronDown__d47Bs","docSelectList":"Docs_docSelectList__sZvi9","contentInnerBar":"Docs_contentInnerBar__oVUjo","leftInner":"Docs_leftInner__RF3OK","centerInner":"Docs_centerInner__bL99U","searchContainer":"Docs_searchContainer__0qCYJ","searchDiv":"Docs_searchDiv__u4Smh","spinner":"Docs_spinner__RE0vP","codeBlock":"Docs_codeBlock__GmOTo","codeBlockTopper":"Docs_codeBlockTopper__nWwNU","codeCopyIcon":"Docs_codeCopyIcon__8Tsch","contentSection":"Docs_contentSection__3OQpo","centerSection":"Docs_centerSection__jxxYw","sdkCenterSection":"Docs_sdkCenterSection__WkN9l","quickStartCenterSection":"Docs_quickStartCenterSection__yktxM","rightSection":"Docs_rightSection__SZw9H","headingSection":"Docs_headingSection__x5be1","docLink":"Docs_docLink__taM7v","rightBarWrap":"Docs_rightBarWrap__jakYW","socialItem":"Docs_socialItem__fuzrp","sdkSocialItem":"Docs_sdkSocialItem__5dt4_","resourcesSideBar":"Docs_resourcesSideBar__lgF62","resourcesMobile":"Docs_resourcesMobile__uiihJ","pageContentTable":"Docs_pageContentTable__fTiVM","pageNavigateRow":"Docs_pageNavigateRow__QcMzN","pageNavigate":"Docs_pageNavigate__CdpBF","pageContentTitle":"Docs_pageContentTitle__EhHKD","pageContentIcon":"Docs_pageContentIcon__iQl8C","pageContentList":"Docs_pageContentList__Lzsbr","pageContentBullet":"Docs_pageContentBullet__DjElc","breadcrumb":"Docs_breadcrumb__bU57t","tocMenu":"Docs_tocMenu__l8_Vh","tocMenuLarge":"Docs_tocMenuLarge__eUA0l","customComponent":"Docs_customComponent___gky_","callout":"Docs_callout__TRexG","calloutIcon":"Docs_calloutIcon__6q_MY","icon":"Docs_icon__GZ_cR","calloutContent":"Docs_calloutContent__MYxQS","sdkDocSection":"Docs_sdkDocSection__vCPp1","methodParameter":"Docs_methodParameter__PZHhd","innerParameterContainer":"Docs_innerParameterContainer__U8ZlW","innerParameterHeading":"Docs_innerParameterHeading__NS93a","sdkRender":"Docs_sdkRender__SrVGr","tocMenuLabel":"Docs_tocMenuLabel__DutJo","tocContents":"Docs_tocContents__HV81g"};

/***/ }),

/***/ 79949:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ pt; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(94192);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(19946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-computed.js
function use_computed_i(e,o){let[u,t]=(0,react.useState)(e),r=(0,use_latest_value/* useLatestValue */.E)(e);return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>t(r.current),[r,t,...o]),u}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(32984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js + 1 modules
var disposables = __webpack_require__(88043);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(61363);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/calculate-active-index.js
function f(r){throw new Error("Unexpected object: "+r)}var calculate_active_index_a=(e=>(e[e.First=0]="First",e[e.Previous=1]="Previous",e[e.Next=2]="Next",e[e.Last=3]="Last",e[e.Specific=4]="Specific",e[e.Nothing=5]="Nothing",e))(calculate_active_index_a||{});function x(r,n){let t=n.resolveItems();if(t.length<=0)return null;let l=n.resolveActiveIndex(),s=l!=null?l:-1,d=(()=>{switch(r.focus){case 0:return t.findIndex(e=>!n.resolveDisabled(e));case 1:{let e=t.slice().reverse().findIndex((i,c,u)=>s!==-1&&u.length-c-1>=s?!1:!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 2:return t.findIndex((e,i)=>i<=s?!1:!n.resolveDisabled(e));case 3:{let e=t.slice().reverse().findIndex(i=>!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 4:return t.findIndex(e=>n.resolveId(e)===r.id);case 5:return null;default:f(r)}})();return d===-1?l:d}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(64103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(84575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(14157);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(39650);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(46045);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/form.js
var utils_form = __webpack_require__(18689);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(15466);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-controllable.js
var use_controllable = __webpack_require__(31147);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js
var ye=(n=>(n[n.Open=0]="Open",n[n.Closed=1]="Closed",n))(ye||{}),xe=(n=>(n[n.Single=0]="Single",n[n.Multi=1]="Multi",n))(xe||{}),Oe=(n=>(n[n.Pointer=0]="Pointer",n[n.Other=1]="Other",n))(Oe||{}),me=(r=>(r[r.OpenListbox=0]="OpenListbox",r[r.CloseListbox=1]="CloseListbox",r[r.SetDisabled=2]="SetDisabled",r[r.SetOrientation=3]="SetOrientation",r[r.GoToOption=4]="GoToOption",r[r.Search=5]="Search",r[r.ClearSearch=6]="ClearSearch",r[r.RegisterOption=7]="RegisterOption",r[r.UnregisterOption=8]="UnregisterOption",r))(me||{});function j(t,i=n=>n){let n=t.activeOptionIndex!==null?t.options[t.activeOptionIndex]:null,e=(0,focus_management/* sortByDomNode */.z2)(i(t.options.slice()),u=>u.dataRef.current.domRef.current),o=n?e.indexOf(n):null;return o===-1&&(o=null),{options:e,activeOptionIndex:o}}let ge={[1](t){return t.disabled||t.listboxState===1?t:{...t,activeOptionIndex:null,listboxState:1}},[0](t){if(t.disabled||t.listboxState===0)return t;let i=t.activeOptionIndex,{value:n,mode:e,compare:o}=t.propsRef.current,u=t.options.findIndex(l=>{let s=l.dataRef.current.value;return (0,match/* match */.E)(e,{[1]:()=>n.some(r=>o(r,s)),[0]:()=>o(n,s)})});return u!==-1&&(i=u),{...t,listboxState:0,activeOptionIndex:i}},[2](t,i){return t.disabled===i.disabled?t:{...t,disabled:i.disabled}},[3](t,i){return t.orientation===i.orientation?t:{...t,orientation:i.orientation}},[4](t,i){var o;if(t.disabled||t.listboxState===1)return t;let n=j(t),e=x(i,{resolveItems:()=>n.options,resolveActiveIndex:()=>n.activeOptionIndex,resolveId:u=>u.id,resolveDisabled:u=>u.dataRef.current.disabled});return{...t,...n,searchQuery:"",activeOptionIndex:e,activationTrigger:(o=i.trigger)!=null?o:1}},[5]:(t,i)=>{if(t.disabled||t.listboxState===1)return t;let e=t.searchQuery!==""?0:1,o=t.searchQuery+i.value.toLowerCase(),l=(t.activeOptionIndex!==null?t.options.slice(t.activeOptionIndex+e).concat(t.options.slice(0,t.activeOptionIndex+e)):t.options).find(d=>{var r;return!d.dataRef.current.disabled&&((r=d.dataRef.current.textValue)==null?void 0:r.startsWith(o))}),s=l?t.options.indexOf(l):-1;return s===-1||s===t.activeOptionIndex?{...t,searchQuery:o}:{...t,searchQuery:o,activeOptionIndex:s,activationTrigger:1}},[6](t){return t.disabled||t.listboxState===1||t.searchQuery===""?t:{...t,searchQuery:""}},[7]:(t,i)=>{let n={id:i.id,dataRef:i.dataRef},e=j(t,o=>[...o,n]);if(t.activeOptionIndex===null){let{value:o,mode:u,compare:l}=t.propsRef.current,s=i.dataRef.current.value;(0,match/* match */.E)(u,{[1]:()=>o.some(r=>l(r,s)),[0]:()=>l(o,s)})&&(e.activeOptionIndex=e.options.indexOf(n))}return{...t,...e}},[8]:(t,i)=>{let n=j(t,e=>{let o=e.findIndex(u=>u.id===i.id);return o!==-1&&e.splice(o,1),e});return{...t,...n,activationTrigger:1}}},K=(0,react.createContext)(null);K.displayName="ListboxContext";function w(t){let i=(0,react.useContext)(K);if(i===null){let n=new Error(`<${t} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,w),n}return i}function Re(t,i){return (0,match/* match */.E)(i.type,ge,t,i)}let ve=react.Fragment,Le=(0,render/* forwardRefWithAs */.yV)(function(i,n){let{value:e,defaultValue:o,name:u,onChange:l,by:s=(p,T)=>p===T,disabled:d=!1,horizontal:r=!1,multiple:x=!1,...S}=i;const g=r?"horizontal":"vertical";let O=(0,use_sync_refs/* useSyncRefs */.T)(n),[m,f]=(0,use_controllable/* useControllable */.q)(e,l,o),b=(0,react.useReducer)(Re,{listboxState:1,propsRef:{current:{value:m,onChange:f,mode:x?1:0,compare:(0,use_event/* useEvent */.z)(typeof s=="string"?(p,T)=>{let C=s;return(p==null?void 0:p[C])===(T==null?void 0:T[C])}:s)}},labelRef:(0,react.createRef)(),buttonRef:(0,react.createRef)(),optionsRef:(0,react.createRef)(),disabled:d,orientation:g,options:[],searchQuery:"",activeOptionIndex:null,activationTrigger:1}),[{listboxState:a,propsRef:c,optionsRef:P,buttonRef:D},M]=b;c.current.value=m,c.current.mode=x?1:0,(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{c.current.onChange=p=>(0,match/* match */.E)(c.current.mode,{[0](){return f(p)},[1](){let T=c.current.value.slice(),{compare:C}=c.current,W=T.findIndex(X=>C(X,p));return W===-1?T.push(p):T.splice(W,1),f(T)}})},[f,c]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>M({type:2,disabled:d}),[d]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>M({type:3,orientation:g}),[g]),(0,use_outside_click/* useOutsideClick */.O)([D,P],(p,T)=>{var C;M({type:1}),(0,focus_management/* isFocusableElement */.sP)(T,focus_management/* FocusableMode.Loose */.tJ.Loose)||(p.preventDefault(),(C=D.current)==null||C.focus())},a===0);let N=(0,react.useMemo)(()=>({open:a===0,disabled:d,value:m}),[a,d,m]),R={ref:O};return react.createElement(K.Provider,{value:b},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(a,{[0]:open_closed/* State.Open */.ZM.Open,[1]:open_closed/* State.Closed */.ZM.Closed})},u!=null&&m!=null&&(0,utils_form/* objectToFormEntries */.t)({[u]:m}).map(([p,T])=>react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features.Hidden */.A.Hidden,...(0,render/* compact */.oA)({key:p,as:"input",type:"hidden",hidden:!0,readOnly:!0,name:p,value:T})})),(0,render/* render */.sY)({ourProps:R,theirProps:S,slot:N,defaultTag:ve,name:"Listbox"})))}),Se="button",Ae=(0,render/* forwardRefWithAs */.yV)(function(i,n){var f;let[e,o]=w("Listbox.Button"),u=(0,use_sync_refs/* useSyncRefs */.T)(e.buttonRef,n),l=`headlessui-listbox-button-${(0,use_id/* useId */.M)()}`,s=(0,use_disposables/* useDisposables */.G)(),d=(0,use_event/* useEvent */.z)(b=>{switch(b.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:case keyboard/* Keys.ArrowDown */.R.ArrowDown:b.preventDefault(),o({type:0}),s.nextFrame(()=>{e.propsRef.current.value||o({type:4,focus:calculate_active_index_a.First})});break;case keyboard/* Keys.ArrowUp */.R.ArrowUp:b.preventDefault(),o({type:0}),s.nextFrame(()=>{e.propsRef.current.value||o({type:4,focus:calculate_active_index_a.Last})});break}}),r=(0,use_event/* useEvent */.z)(b=>{switch(b.key){case keyboard/* Keys.Space */.R.Space:b.preventDefault();break}}),x=(0,use_event/* useEvent */.z)(b=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(b.currentTarget))return b.preventDefault();e.listboxState===0?(o({type:1}),s.nextFrame(()=>{var a;return(a=e.buttonRef.current)==null?void 0:a.focus({preventScroll:!0})})):(b.preventDefault(),o({type:0}))}),S=use_computed_i(()=>{if(!!e.labelRef.current)return[e.labelRef.current.id,l].join(" ")},[e.labelRef.current,l]),g=(0,react.useMemo)(()=>({open:e.listboxState===0,disabled:e.disabled,value:e.propsRef.current.value}),[e]),O=i,m={ref:u,id:l,type:(0,use_resolve_button_type/* useResolveButtonType */.f)(i,e.buttonRef),"aria-haspopup":!0,"aria-controls":(f=e.optionsRef.current)==null?void 0:f.id,"aria-expanded":e.disabled?void 0:e.listboxState===0,"aria-labelledby":S,disabled:e.disabled,onKeyDown:d,onKeyUp:r,onClick:x};return (0,render/* render */.sY)({ourProps:m,theirProps:O,slot:g,defaultTag:Se,name:"Listbox.Button"})}),he="label",Pe=(0,render/* forwardRefWithAs */.yV)(function(i,n){let[e]=w("Listbox.Label"),o=`headlessui-listbox-label-${(0,use_id/* useId */.M)()}`,u=(0,use_sync_refs/* useSyncRefs */.T)(e.labelRef,n),l=(0,use_event/* useEvent */.z)(()=>{var x;return(x=e.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})}),s=(0,react.useMemo)(()=>({open:e.listboxState===0,disabled:e.disabled}),[e]);return (0,render/* render */.sY)({ourProps:{ref:u,id:o,onClick:l},theirProps:i,slot:s,defaultTag:he,name:"Listbox.Label"})}),Ce="ul",De=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static,Me=(0,render/* forwardRefWithAs */.yV)(function(i,n){var b;let[e,o]=w("Listbox.Options"),u=(0,use_sync_refs/* useSyncRefs */.T)(e.optionsRef,n),l=`headlessui-listbox-options-${(0,use_id/* useId */.M)()}`,s=(0,use_disposables/* useDisposables */.G)(),d=(0,use_disposables/* useDisposables */.G)(),r=(0,open_closed/* useOpenClosed */.oJ)(),x=(()=>r!==null?r===open_closed/* State.Open */.ZM.Open:e.listboxState===0)();(0,react.useEffect)(()=>{var c;let a=e.optionsRef.current;!a||e.listboxState===0&&a!==((c=(0,owner/* getOwnerDocument */.r)(a))==null?void 0:c.activeElement)&&a.focus({preventScroll:!0})},[e.listboxState,e.optionsRef]);let S=(0,use_event/* useEvent */.z)(a=>{switch(d.dispose(),a.key){case keyboard/* Keys.Space */.R.Space:if(e.searchQuery!=="")return a.preventDefault(),a.stopPropagation(),o({type:5,value:a.key});case keyboard/* Keys.Enter */.R.Enter:if(a.preventDefault(),a.stopPropagation(),e.activeOptionIndex!==null){let{dataRef:c}=e.options[e.activeOptionIndex];e.propsRef.current.onChange(c.current.value)}e.propsRef.current.mode===0&&(o({type:1}),(0,disposables/* disposables */.k)().nextFrame(()=>{var c;return(c=e.buttonRef.current)==null?void 0:c.focus({preventScroll:!0})}));break;case (0,match/* match */.E)(e.orientation,{vertical:keyboard/* Keys.ArrowDown */.R.ArrowDown,horizontal:keyboard/* Keys.ArrowRight */.R.ArrowRight}):return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index_a.Next});case (0,match/* match */.E)(e.orientation,{vertical:keyboard/* Keys.ArrowUp */.R.ArrowUp,horizontal:keyboard/* Keys.ArrowLeft */.R.ArrowLeft}):return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index_a.Previous});case keyboard/* Keys.Home */.R.Home:case keyboard/* Keys.PageUp */.R.PageUp:return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index_a.First});case keyboard/* Keys.End */.R.End:case keyboard/* Keys.PageDown */.R.PageDown:return a.preventDefault(),a.stopPropagation(),o({type:4,focus:calculate_active_index_a.Last});case keyboard/* Keys.Escape */.R.Escape:return a.preventDefault(),a.stopPropagation(),o({type:1}),s.nextFrame(()=>{var c;return(c=e.buttonRef.current)==null?void 0:c.focus({preventScroll:!0})});case keyboard/* Keys.Tab */.R.Tab:a.preventDefault(),a.stopPropagation();break;default:a.key.length===1&&(o({type:5,value:a.key}),d.setTimeout(()=>o({type:6}),350));break}}),g=use_computed_i(()=>{var a,c,P;return(P=(a=e.labelRef.current)==null?void 0:a.id)!=null?P:(c=e.buttonRef.current)==null?void 0:c.id},[e.labelRef.current,e.buttonRef.current]),O=(0,react.useMemo)(()=>({open:e.listboxState===0}),[e]),m=i,f={"aria-activedescendant":e.activeOptionIndex===null||(b=e.options[e.activeOptionIndex])==null?void 0:b.id,"aria-multiselectable":e.propsRef.current.mode===1?!0:void 0,"aria-labelledby":g,"aria-orientation":e.orientation,id:l,onKeyDown:S,role:"listbox",tabIndex:0,ref:u};return (0,render/* render */.sY)({ourProps:f,theirProps:m,slot:O,defaultTag:Ce,features:De,visible:x,name:"Listbox.Options"})}),Ee="li",Ie=(0,render/* forwardRefWithAs */.yV)(function(i,n){let{disabled:e=!1,value:o,...u}=i,[l,s]=w("Listbox.Option"),d=`headlessui-listbox-option-${(0,use_id/* useId */.M)()}`,r=l.activeOptionIndex!==null?l.options[l.activeOptionIndex].id===d:!1,{value:x,compare:S}=l.propsRef.current,g=(0,match/* match */.E)(l.propsRef.current.mode,{[1]:()=>x.some(R=>S(R,o)),[0]:()=>S(x,o)}),O=(0,react.useRef)(null),m=(0,use_sync_refs/* useSyncRefs */.T)(n,O);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(l.listboxState!==0||!r||l.activationTrigger===0)return;let R=(0,disposables/* disposables */.k)();return R.requestAnimationFrame(()=>{var p,T;(T=(p=O.current)==null?void 0:p.scrollIntoView)==null||T.call(p,{block:"nearest"})}),R.dispose},[O,r,l.listboxState,l.activationTrigger,l.activeOptionIndex]);let f=(0,react.useRef)({disabled:e,value:o,domRef:O});(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{f.current.disabled=e},[f,e]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{f.current.value=o},[f,o]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{var R,p;f.current.textValue=(p=(R=O.current)==null?void 0:R.textContent)==null?void 0:p.toLowerCase()},[f,O]);let b=(0,use_event/* useEvent */.z)(()=>l.propsRef.current.onChange(o));(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(s({type:7,id:d,dataRef:f}),()=>s({type:8,id:d})),[f,d]);let a=(0,use_event/* useEvent */.z)(R=>{if(e)return R.preventDefault();b(),l.propsRef.current.mode===0&&(s({type:1}),(0,disposables/* disposables */.k)().nextFrame(()=>{var p;return(p=l.buttonRef.current)==null?void 0:p.focus({preventScroll:!0})}))}),c=(0,use_event/* useEvent */.z)(()=>{if(e)return s({type:4,focus:calculate_active_index_a.Nothing});s({type:4,focus:calculate_active_index_a.Specific,id:d})}),P=(0,use_event/* useEvent */.z)(()=>{e||r||s({type:4,focus:calculate_active_index_a.Specific,id:d,trigger:0})}),D=(0,use_event/* useEvent */.z)(()=>{e||!r||s({type:4,focus:calculate_active_index_a.Nothing})}),M=(0,react.useMemo)(()=>({active:r,selected:g,disabled:e}),[r,g,e]);return (0,render/* render */.sY)({ourProps:{id:d,ref:m,role:"option",tabIndex:e===!0?void 0:-1,"aria-disabled":e===!0?!0:void 0,"aria-selected":g,disabled:void 0,onClick:a,onFocus:c,onPointerMove:P,onMouseMove:P,onPointerLeave:D,onMouseLeave:D},theirProps:u,slot:M,defaultTag:Ee,name:"Listbox.Option"})}),pt=Object.assign(Le,{Button:Ae,Label:Pe,Options:Me,Option:Ie});


/***/ }),

/***/ 31147:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ T; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73781);
function T(l,r,c){let[i,s]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(c),e=l!==void 0,t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1),d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);return e&&!t.current&&!u.current?(u.current=!0,t.current=e,console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")):!e&&t.current&&!d.current&&(d.current=!0,t.current=e,console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")),[e?l:i,(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(n=>(e||s(n),r==null?void 0:r(n)))]}


/***/ }),

/***/ 18689:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ p; },
/* harmony export */   "t": function() { return /* binding */ e; }
/* harmony export */ });
function e(n={},r=null,t=[]){for(let[i,o]of Object.entries(n))f(t,s(r,i),o);return t}function s(n,r){return n?n+"["+r+"]":r}function f(n,r,t){if(Array.isArray(t))for(let[i,o]of t.entries())f(n,s(r,i.toString()),o);else t instanceof Date?n.push([r,t.toISOString()]):typeof t=="boolean"?n.push([r,t?"1":"0"]):typeof t=="string"?n.push([r,t]):typeof t=="number"?n.push([r,`${t}`]):t==null?n.push([r,""]):e(t,r,n)}function p(n){var t;let r=(t=n==null?void 0:n.form)!=null?t:n.closest("form");if(!!r){for(let i of r.elements)if(i.tagName==="INPUT"&&i.type==="submit"||i.tagName==="BUTTON"&&i.type==="submit"||i.nodeName==="INPUT"&&i.type==="image"){i.click();return}}}


/***/ }),

/***/ 46032:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function ChevronUpDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronUpDownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,2013,3826,1399,5675,1443,3146,4117,7911,2323,8558,9774,2888,179], function() { return __webpack_exec__(16161); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);